export default __webpack_public_path__ + "static/media/reach_in-dims.da9f5b5f.png";